import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=56113054&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56113054')) {
      api.createRecord('56113054', component.options)
    } else {
      api.reload('56113054', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=56113054&", function () {
      api.rerender('56113054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hZPLJb8rdG3R/JS/cancellationPolicy.vue"
export default component.exports